import React from 'react';
import './GradientButton.css';

const GradientButton = ({
  children,
  onClick,
  disabled = false,
  type = 'button',
  className = '',
  ...props
}) => {
  const buttonClassName = className
    .split(/\s+/)
    .filter((classToken) => classToken && classToken !== 'flex-1')
    .join(' ');

  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={`gradient-button ${buttonClassName}`.trim()}
      {...props}
    >
      {children}
    </button>
  );
};

export default GradientButton;
